import GeneralSettings from './container';

export default GeneralSettings;



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/index.js